import React, { useEffect, useState  } from 'react';
import { useDispatch } from 'react-redux';
import { checkConsentStatus } from '../actions';
import { postMessageSuccess } from '../helpers/postMessage';
import ThemedSpinner from './ThemedSpinner';
//import ConsentError from './ConsentError';

const ConsentTransfer = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    let intervalId;

    const pollConsentStatus = async () => {
      try {
        await dispatch(checkConsentStatus(props.consent_guid, props.institution));
      } catch (err) {
      }
    };
      intervalId = setInterval(pollConsentStatus, 7000);
    
      return () => clearInterval(intervalId);
     
  });

  const redirectUrl = props.redirect_url;
  const [showUI, setShowUI] = useState(false); // controls message + button visibility
  const [clicked, setClicked] = useState(false); // to disable/hide after click

  useEffect(() => {
    if (!redirectUrl) return;

    const timer = setTimeout(() => {
      // Try to auto-open after 3s (may be blocked)
      const win = window.open(redirectUrl, "_blank");

      const opened = win && !win.closed && typeof win.closed !== "undefined";
      if (!opened) {
        // Pop-up blocked: show message + button
        setShowUI(true);
      } else {
        const slug = props.institution.slug || props.institution.name || props.consent_guid;
        dispatch(postMessageSuccess("awaiting-consent", {slug: slug}));
        // Auto-open succeeded; optionally hide UI if you were showing it
        setShowUI(false);
        try { win.focus(); } catch {}
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [redirectUrl, dispatch, props.consent_guid, props.institution.name, props.institution.slug]);

  const handleClick = () => {
    if (!redirectUrl) return;

    //window.open(redirectUrl, "_blank");
    // disable & hide
    const slug = props.institution.slug || props.institution.name || props.consent_guid;
    dispatch(postMessageSuccess("awaiting-consent", {slug: slug}));
    setClicked(true);
    setShowUI(false);
  };

  if (clicked) return null;


  return (
    <div id="intro">
      <div className="consent-data-wrapper transfer-to-provider">
        <h2 className="form-group text-center">
          Transferring you to <strong>{props.institution.name}</strong>
        </h2>
        <ThemedSpinner theme={props.theme} />
        <div className="form-group text-center">
          <p>We are redirecting you to the {props.institution.name} where you will login securely before viewing and authorising this request.</p>
          
        {showUI && (
            <>
              <span id="redirectMsg" style={{ marginRight: 8 }}>
                If you are not redirected to the bank page, please{" "}
              </span>
              <a id="openBtn" target="_blank" rel="noopenernoopener noreferrer" href={redirectUrl} onClick={handleClick}>click here</a>
            </>
          )}

        </div>
      </div>
    </div>
  );
};

export default ConsentTransfer;